import { useLocation } from 'react-router'

export const useWebViewModal = () => {
  const location = useLocation()

  return location ? location.pathname.includes('/trip-planner/webView') : false
}
